import React from 'react';
import BaseDropdown, { TBaseDropdownProps } from './BaseDropdown';
import { useGetItemGroups } from 'api/hooks/useGetItemGroups';

const ItemGroupsDropdown = (
	props: TBaseDropdownProps & {
		projectCode: string | null;
		newOption: string | null;
	}
) => {
	const { projectCode, newOption } = props;
	const { data: groups = [], isFetching } = useGetItemGroups(
		projectCode as string,
		{
			enabled: !!projectCode,
		}
	);
	const options = groups.map((x) => ({ value: x, label: x }));

	// ItemGroupsDropdown acts as a select dropdown for existing options.
	// If a user types a custom value not in the list, it adds that value as a new selectable option.
	if (newOption) {
		options.push({ value: newOption, label: newOption });
	}

	return (
		<BaseDropdown
			{...props}
			isLoading={isFetching}
			options={options}
			isClearable
			isCreatable
			blurInputOnSelect
		/>
	);
};

ItemGroupsDropdown.displayName = 'ItemGroupsDropdown';

export { ItemGroupsDropdown };
